import { c as _c } from "react/compiler-runtime";
import type { ComponentType, ReactNode, SVGProps } from "react";
import { Activity, AlertTriangle, Anchor, Armchair, ArrowUp, Axe, Bandage, BarChart, BarChart3, Bed, Bell, Bolt, Bomb, BookHeart, BookMarked, BookOpen, BookOpenText, Bot, Building2, Bus, Cake, Calculator, CalendarHeart, Camera, Candy, Cat, CheckCircle, ChefHat, ChevronDown, ChevronUp, Circle, CircleHelp, Clapperboard, ClipboardList, Clock, Cloud, CloudFog, CloudRain, CloudSun, Coffee, Compass, Cookie, CookingPot, Cpu, CreditCard, Crosshair, Crown, CupSoda, Database, Dice5, Disc3, DoorOpen, Download, Drumstick, Dumbbell, Eye, EyeOff, FastForward, Feather, FileText, Flag, FlaskConical, Flower, Flower2, Footprints, Gem, Ghost, Gift, GitFork, GitMerge, Glasses, Globe, Hammer, Hand, HandHeart, Handshake, Headphones, Heart, HeartHandshake, HeartPulse, Home, House, IceCreamBowl, Image as ImageIcon, Infinity, Key, KeyRound, Lamp, Landmark, Laugh, Layers, Leaf, Library, Lightbulb, Lock, LogIn, Map, Menu, Megaphone, MessageCircle, MessageCircleHeart, MessageCircleOff, MessageCircleQuestion, MessagesSquare, Mic, MicOff, Microscope, Milk, Moon, MoonStar, MousePointerClick, Mountain, MountainSnow, Music, Music2, Package, PackageCheck, Palette, Pause, Play, PartyPopper, PawPrint, PiggyBank, Popcorn, Puzzle, Pyramid, Radar, Receipt, Rocket, Ruler, Salad, Sandwich, ScanSearch, Scroll, Search, SearchCheck, Send, Server, Settings, Shapes, Shield, ShieldCheck, ShieldHalf, Skull, Smile, Snowflake, Sofa, Soup, Sparkle, Star, Store, Sun, SunMedium, Swords, Target, Telescope, TextAlignCenter, TextAlignEnd, TextAlignJustify, TextAlignStart, Timer, Tornado, TrendingUp, Type, UserMinus, UserPlus, UserSearch, Users, UsersRound, Utensils, Video, Vote, Wallet, WandSparkles, Waves, Wine, Wrench, X, Zap } from "lucide-react";
type LucideComponent = ComponentType<SVGProps<SVGSVGElement> & {
  size?: number | string;
  strokeWidth?: number;
}>;
const LOCAL_ICON_NAMES = ["brain", "sparkles", "share", "link", "link-off", "check", "arrow-right", "arrow-left", "refresh", "flame", "wind", "sprout", "droplet", "bold", "italic", "heading-1", "heading-2", "heading-3", "paragraph", "list-bulleted", "list-ordered", "quote", "table", "table-row-add", "table-row-del", "table-col-add", "table-col-del", "table-header", "table-del", "undo", "redo", "code", "log-out"] as const;
export type LocalIconName = (typeof LOCAL_ICON_NAMES)[number];
const LUCIDE_ICONS = {
  activity: Activity,
  "alert-triangle": AlertTriangle,
  "align-center": TextAlignCenter,
  "align-justify": TextAlignJustify,
  "align-left": TextAlignStart,
  "align-right": TextAlignEnd,
  anchor: Anchor,
  armchair: Armchair,
  "arrow-up": ArrowUp,
  axe: Axe,
  bandage: Bandage,
  "bar-chart": BarChart,
  "bar-chart-3": BarChart3,
  bed: Bed,
  bell: Bell,
  bolt: Bolt,
  bomb: Bomb,
  "book-heart": BookHeart,
  "book-marked": BookMarked,
  "book-open": BookOpen,
  "book-open-text": BookOpenText,
  bot: Bot,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "building-2": Building2,
  bus: Bus,
  cake: Cake,
  calculator: Calculator,
  "calendar-heart": CalendarHeart,
  camera: Camera,
  candy: Candy,
  cat: Cat,
  "check-circle": CheckCircle,
  "chef-hat": ChefHat,
  circle: Circle,
  "circle-help": CircleHelp,
  clapperboard: Clapperboard,
  "clipboard-list": ClipboardList,
  clock: Clock,
  cloud: Cloud,
  "cloud-fog": CloudFog,
  "cloud-rain": CloudRain,
  "cloud-sun": CloudSun,
  coffee: Coffee,
  compass: Compass,
  cookie: Cookie,
  "cooking-pot": CookingPot,
  cpu: Cpu,
  "credit-card": CreditCard,
  crosshair: Crosshair,
  crown: Crown,
  "cup-soda": CupSoda,
  database: Database,
  "dice-5": Dice5,
  "disc-3": Disc3,
  "door-open": DoorOpen,
  download: Download,
  drumstick: Drumstick,
  dumbbell: Dumbbell,
  eye: Eye,
  "eye-off": EyeOff,
  "fast-forward": FastForward,
  feather: Feather,
  "file-text": FileText,
  flag: Flag,
  "flask-conical": FlaskConical,
  flower: Flower,
  "flower-2": Flower2,
  footprints: Footprints,
  gem: Gem,
  ghost: Ghost,
  gift: Gift,
  "git-fork": GitFork,
  "git-merge": GitMerge,
  glasses: Glasses,
  globe: Globe,
  hammer: Hammer,
  hand: Hand,
  "hand-heart": HandHeart,
  handshake: Handshake,
  headphones: Headphones,
  heart: Heart,
  "heart-handshake": HeartHandshake,
  "heart-pulse": HeartPulse,
  home: Home,
  house: House,
  "ice-cream-bowl": IceCreamBowl,
  image: ImageIcon,
  infinity: Infinity,
  key: Key,
  "key-round": KeyRound,
  lamp: Lamp,
  landmark: Landmark,
  laugh: Laugh,
  layers: Layers,
  leaf: Leaf,
  library: Library,
  lightbulb: Lightbulb,
  lock: Lock,
  "log-in": LogIn,
  map: Map,
  menu: Menu,
  megaphone: Megaphone,
  "message-circle": MessageCircle,
  "message-circle-heart": MessageCircleHeart,
  "message-circle-off": MessageCircleOff,
  "message-circle-question": MessageCircleQuestion,
  "messages-square": MessagesSquare,
  mic: Mic,
  "mic-off": MicOff,
  microscope: Microscope,
  milk: Milk,
  moon: Moon,
  "moon-star": MoonStar,
  "mouse-pointer-click": MousePointerClick,
  mountain: Mountain,
  "mountain-snow": MountainSnow,
  music: Music,
  "music-2": Music2,
  package: Package,
  "package-check": PackageCheck,
  palette: Palette,
  pause: Pause,
  play: Play,
  "party-popper": PartyPopper,
  "paw-print": PawPrint,
  "piggy-bank": PiggyBank,
  popcorn: Popcorn,
  puzzle: Puzzle,
  pyramid: Pyramid,
  radar: Radar,
  receipt: Receipt,
  rocket: Rocket,
  ruler: Ruler,
  salad: Salad,
  sandwich: Sandwich,
  "scan-search": ScanSearch,
  scroll: Scroll,
  search: Search,
  "search-check": SearchCheck,
  send: Send,
  server: Server,
  settings: Settings,
  shapes: Shapes,
  shield: Shield,
  "shield-check": ShieldCheck,
  "shield-half": ShieldHalf,
  skull: Skull,
  smile: Smile,
  snowflake: Snowflake,
  sofa: Sofa,
  soup: Soup,
  sparkle: Sparkle,
  star: Star,
  store: Store,
  sun: Sun,
  "sun-medium": SunMedium,
  swords: Swords,
  target: Target,
  telescope: Telescope,
  type: Type,
  timer: Timer,
  tornado: Tornado,
  "trending-up": TrendingUp,
  "user-minus": UserMinus,
  "user-plus": UserPlus,
  "user-search": UserSearch,
  users: Users,
  "users-round": UsersRound,
  utensils: Utensils,
  video: Video,
  vote: Vote,
  wallet: Wallet,
  "wand-sparkles": WandSparkles,
  waves: Waves,
  wine: Wine,
  wrench: Wrench,
  x: X,
  close: X,
  zap: Zap
} satisfies Record<string, LucideComponent>;
export type LucideIconName = keyof typeof LUCIDE_ICONS;
export type IconName = LocalIconName | LucideIconName;
type Props = Omit<SVGProps<SVGSVGElement>, "children"> & {
  name: IconName;
  size?: number | string;
  title?: string;
  strokeWidth?: number;
};
const PATHS: Record<LocalIconName, ReactNode> = {
  brain: <>
      <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" />
      <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" />
    </>,
  sparkles: <>
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275z" />
      <path d="M5 3v4" />
      <path d="M19 17v4" />
      <path d="M3 5h4" />
      <path d="M17 19h4" />
    </>,
  share: <>
      <path d="M12 2v13" />
      <path d="m16 6-4-4-4 4" />
      <path d="M20 13v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7" />
    </>,
  link: <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>,
  check: <path d="M20 6 9 17l-5-5" />,
  "arrow-right": <>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </>,
  "arrow-left": <>
      <path d="M19 12H5" />
      <path d="m12 19-7-7 7-7" />
    </>,
  refresh: <>
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5" />
    </>,
  flame: <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />,
  wind: <>
      <path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2" />
      <path d="M9.6 4.6A2 2 0 1 1 11 8H2" />
      <path d="M12.6 19.4A2 2 0 1 0 14 16H2" />
    </>,
  sprout: <>
      <path d="M7 20h10" />
      <path d="M10 20c5.5-2.5.8-6.4 3-10" />
      <path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z" />
      <path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z" />
    </>,
  droplet: <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" />,
  "link-off": <>
      <path d="M18.84 12.25 20.5 10.6a5 5 0 0 0-7.07-7.07L11.75 5.2" />
      <path d="M5.17 11.75 3.5 13.4a5 5 0 0 0 7.07 7.07L12.25 18.8" />
      <path d="M2 2l20 20" />
    </>,
  bold: <>
      <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
      <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
    </>,
  italic: <>
      <line x1="19" y1="4" x2="10" y2="4" />
      <line x1="14" y1="20" x2="5" y2="20" />
      <line x1="15" y1="4" x2="9" y2="20" />
    </>,
  "heading-1": <>
      <path d="M4 12h8" />
      <path d="M4 18V6" />
      <path d="M12 18V6" />
      <path d="m17 12 3-2v8" />
    </>,
  "heading-2": <>
      <path d="M4 12h8" />
      <path d="M4 18V6" />
      <path d="M12 18V6" />
      <path d="M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1" />
    </>,
  "heading-3": <>
      <path d="M4 12h8" />
      <path d="M4 18V6" />
      <path d="M12 18V6" />
      <path d="M17.5 10.5c1.7-1 3.5 0 3.5 1.8 0 1.8-1.5 1.8-2 1.8h-1" />
      <path d="M18 14h1c2 0 2.5 1 2.5 2 0 1.5-2 2.5-4 1.3" />
    </>,
  paragraph: <>
      <path d="M13 4v16" />
      <path d="M17 4v16" />
      <path d="M19 4H9.5a4.5 4.5 0 0 0 0 9H13" />
    </>,
  "list-bulleted": <>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </>,
  "list-ordered": <>
      <line x1="10" y1="6" x2="21" y2="6" />
      <line x1="10" y1="12" x2="21" y2="12" />
      <line x1="10" y1="18" x2="21" y2="18" />
      <path d="M4 6h1v4" />
      <path d="M4 10h2" />
      <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" />
    </>,
  quote: <>
      <path d="M3 21c3 0 7-1 7-8V5H3v8h4" />
      <path d="M14 21c3 0 7-1 7-8V5h-7v8h4" />
    </>,
  table: <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="12" y1="3" x2="12" y2="21" />
    </>,
  "table-row-add": <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <path d="M12 17.5v3" />
      <path d="M10.5 19h3" />
    </>,
  "table-row-del": <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <path d="M9 19.5h6" />
    </>,
  "table-col-add": <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="9" y1="3" x2="9" y2="21" />
      <line x1="15" y1="3" x2="15" y2="21" />
      <path d="M18.5 12h3" />
      <path d="M20 10.5v3" />
    </>,
  "table-col-del": <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="9" y1="3" x2="9" y2="21" />
      <line x1="15" y1="3" x2="15" y2="21" />
      <path d="M18.5 12h3" />
    </>,
  "table-header": <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <path d="M3 9h18v-4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" fill="currentColor" fillOpacity="0.15" />
    </>,
  "table-del": <>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="12" y1="3" x2="12" y2="21" />
      <line x1="4" y1="4" x2="20" y2="20" />
    </>,
  undo: <>
      <path d="M3 7v6h6" />
      <path d="M3 13a9 9 0 1 0 3-7.7L3 8" />
    </>,
  redo: <>
      <path d="M21 7v6h-6" />
      <path d="M21 13a9 9 0 1 1-3-7.7L21 8" />
    </>,
  code: <>
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </>,
  "log-out": <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" x2="9" y1="12" y2="12" />
    </>
};
function isLocalIcon(name: IconName): name is LocalIconName {
  return (LOCAL_ICON_NAMES as readonly string[]).includes(name);
}
export default function Icon(t0) {
  const $ = _c(28);
  let className;
  let name;
  let rest;
  let t1;
  let t2;
  let title;
  if ($[0] !== t0) {
    ({
      name,
      size: t1,
      title,
      strokeWidth: t2,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = name;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
    $[6] = title;
  } else {
    className = $[1];
    name = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
    title = $[6];
  }
  const size = t1 === undefined ? 20 : t1;
  const strokeWidth = t2 === undefined ? 2 : t2;
  const accessible = Boolean(title);
  if (!isLocalIcon(name)) {
    const LucideComp = LUCIDE_ICONS[name];
    if (!LucideComp) {
      return null;
    }
    const t3 = accessible ? "img" : undefined;
    const t4 = accessible ? undefined : true;
    const t5 = accessible ? title : undefined;
    let t6;
    if ($[7] !== LucideComp || $[8] !== className || $[9] !== rest || $[10] !== size || $[11] !== strokeWidth || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
      t6 = <LucideComp size={size} strokeWidth={strokeWidth} className={className} role={t3} aria-hidden={t4} aria-label={t5} focusable="false" {...rest} />;
      $[7] = LucideComp;
      $[8] = className;
      $[9] = rest;
      $[10] = size;
      $[11] = strokeWidth;
      $[12] = t3;
      $[13] = t4;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  const t3 = accessible ? "img" : undefined;
  const t4 = accessible ? undefined : true;
  let t5;
  if ($[16] !== accessible || $[17] !== title) {
    t5 = accessible ? <title>{title}</title> : null;
    $[16] = accessible;
    $[17] = title;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = PATHS[name];
  let t7;
  if ($[19] !== className || $[20] !== rest || $[21] !== size || $[22] !== strokeWidth || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} role={t3} aria-hidden={t4} focusable="false" {...rest}>{t5}{t6}</svg>;
    $[19] = className;
    $[20] = rest;
    $[21] = size;
    $[22] = strokeWidth;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}